var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('loading-page'):_c('list-files',{attrs:{"files":_vm.files}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }